import React from "react";

/**
 * Reveals its children once they scroll into view. The animation itself lives
 * in index.css (`.reveal`) so it stays consistent everywhere and respects
 * `prefers-reduced-motion`.
 */
export default function FadeInSection({ children, delay, className = "" }) {
    const [isVisible, setVisible] = React.useState(false);
    const domRef = React.useRef();

    React.useEffect(() => {
        const current = domRef.current;
        if (!current) return undefined;

        const observer = new IntersectionObserver(
            entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        setVisible(true);
                        observer.unobserve(entry.target);
                    }
                });
            },
            { threshold: 0.12, rootMargin: "0px 0px -8% 0px" }
        );

        observer.observe(current);
        return () => observer.disconnect();
    }, []);

    return (
        <div
            ref={domRef}
            className={`reveal ${isVisible ? "is-visible" : ""} ${className}`}
            style={delay ? { transitionDelay: delay } : undefined}
        >
            {children}
        </div>
    );
}
